//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useRef, useState } from 'react';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';

// === COMPONENTS ===
import Collapsible, { Header } from 'components/Collapsible';
import Styled from 'components/Styled/Styled';
import Field  from '../Field/Field';

// === HOOKS ===
import { useFile } from 'pages/FileViewer/components/FileContext/FileContext';
import useOnVisible from 'components/hooks/useOnVisible/useOnVisible';

// === API ===
import { on, removeListener, sendMessageData } from 'api/prokey/prokey.websocket';
import { CardHeader } from '@mui/material';

//#endregion


//-----------------------------------------------------------------
export default function Block(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]
 
  const { id, is_comp = false } = props;

  const theme = useTheme();

  const { file_id } = useFile();

  const [ block    , setBlock    ] = useState({});
  const [ has_focus, setHasFocus ] = useState(false);
  
  const ref = useRef();
  const [is_visible] = useOnVisible(ref);

  //#endregion

  //#region [STYLES]

  const grid = { display : 'grid' };
  const flex = { display : 'flex' };
  const wrap = { flexWrap: 'wrap' };
  const overflow   = { overflow  : 'auto' };
  const overflow_x = { overflowX : 'auto' };

  //#endregion
  
  //#region [EFFECT]
  
  useEffect( () => {
    const BLOCK = is_comp ? 'FILE_COMPARISON_BLOCK' : 'FILE_BLOCK';
    
    //-----------------------------------------------------------------
    function handleBlock( data ) {
      //-----------------------------------------------------------------
      if( id !== data.id ) return;
      setBlock( data );
    }

    on( BLOCK, handleBlock );

    return () => {
      removeListener( BLOCK, handleBlock );
    }
  }, [is_comp] )
      
  useEffect( () => {
    if( !is_visible ) return;
    const type = is_comp ? 'FILE_REQUEST_COMPARISON_BLOCK' : 'FILE_REQUEST_BLOCK';
    sendMessageData( type, { file_id, block_id: id } );
  }, [id,is_visible] )

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const color = is_comp ? theme.palette.secondary.main : '#ffa500';
    const bg = has_focus ? { background: color } : { background: theme.palette.primary.main }
    return (
      <Styled styles={[ { background: theme.palette.background.primary[theme.palette.mode] }, { padding: '6px 0 6px 0' } ]}>
        <Styled styles={[ { fontSize: '18px', fontWeight: 'bold' }, { paddingLeft: '12px' } ]}>{block.header}</Styled>
        { block.is_table ? renderTable() : displayFields() }
      </Styled>
    );
  }

  //-----------------------------------------------------------------
  function renderTable() {
    //-----------------------------------------------------------------
    const gridTemplateColumns = block.columns?.map((col) => {
        let val = `fit-content(${col.length * 11}px)`;
        return val;
      })
      .join(' ');

    return (
      <Styled ref={ref} styles={[overflow_x]} >
        <Styled styles={[grid, overflow_x, {gridTemplateColumns},  ]}>
          {renderTableHeaders()}
          {block.fields?.map( id => ( <Field key={id} id={id} is_comp={is_comp} /> ))}
        </Styled>
      </Styled>
    )
  }

  function renderTableHeaders() {
    return block.columns?.map((col, index) => {
      return <Styled key={index} styles={[ { paddingLeft: '24px' } ]}>{col.header}</Styled>;
    })
  }


  //-----------------------------------------------------------------
  function displayFields() {
    //-----------------------------------------------------------------
    const fields = block.fields?.map( id => ( <Field key={id} id={id} is_comp={is_comp} /> )) || []
    return (
      <Styled ref={ref} styles={[ flex, wrap, overflow, ]}>
        {fields}
      </Styled>
    );
  }

  //#endregion

  return display();
}